:host {
  display: block;
  position: relative;
}

%highlight {
  font-weight: 700;
  background: var(--spw-color-themes-grey-grey-100);
}

.spw-table-container {
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  max-height: var(--spw-table-max-height);
  border-radius: 4px;
  outline: 1px solid var(--spw-color-themes-grey-grey-300);
  outline-offset: -1px;
  position: relative;
}

.spw-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  min-width: var(--spw-table-min-width);
  border-radius: 4px;
  position: relative;
}
